<template>
  <div class="contact">
    <div class="contact__wrapper">
      <div class="contact__qr">
        <h5 class="contact__title">联系商业客服</h5>
        <el-image class="contact__qrcode" fit="contain" src="@/assets/img/home/official_qrcode.jpg"></el-image>
        <p class="contact__phone">
          <a href="tel:021-52991060">021-52991060</a>
        </p>
        <p class="contact__email">
          <a href="mailto:general@shangchuanba.com">合作邮箱：general@shangchuanba.com</a>
        </p>
      </div>
      <div class="contact__form">
        <h5 class="contact__title">留下你的联系方式</h5>
        <p class="contact__intro">合作助手会尽快致电给您</p>
        <el-form class="form" ref="refContact" :rules="rules" :model="form">
          <el-form-item class="form__item" prop="name">
            <el-input placeholder="联系人" v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item class="form__item" prop="mobile">
            <el-input placeholder="联系电话" maxlength="11" v-model="form.mobile"></el-input>
          </el-form-item>
          <el-form-item class="form__item" prop="message">
            <el-input placeholder="留言" :rows="4" type="textarea" resize="none" v-model="form.message"></el-input>
          </el-form-item>
          <el-button type="primary" class="form__btn" @click="saveContact">成为合作伙伴</el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { REQUEST_CODES } from "~/constants/const-http";

import { homeSaveContact } from "~/services/product";

export default {
  data() {
    return {
      rules: {
        name: [
          { required: true, message: "请填写联系人姓名", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号格式不对",
            trigger: "blur",
          },
        ],
      },
      form: {
        name: "",
        mobile: "",
        message: "",
      },
    };
  },
  methods: {
    async saveContact() {
      this.$refs.refContact.validate(async (valid) => {
        if (valid) {
          const { code, msg } = await homeSaveContact(this.form);
          if (code !== REQUEST_CODES.ERROR_OK) return this.$message.error(msg);

          this.$message.success("提交成功");
          this.$refs.refContact.resetFields()
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>

.contact {
  padding-top: 65px;
  padding-bottom: 70px;
  &__wrapper {
    width: 895px;
    margin: 0 auto;
    border-radius: 12px;
    box-shadow: 0px 2px 20px 0px rgba(200, 183, 165, 0.43);
    display: flex;
    background-color: #fff;
    position: relative;
    padding-bottom: 45px;
    > div {
      flex: 1;
      padding-top: 45px;
      text-align: center;
    }
    &::before {
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      height: 345px;
      border-left: 1px solid rgba(#dee2e6, 0.5);
    }
  }
  &__qr {
    color: #495057;
    font-size: 18px;
  }
  &__qrcode {
    width: 146px;
    height: 146px;
    margin-top: 44px;
  }
  &__phone {
    padding: 26px 0 18px;
  }
  &__form {
  }
  &__title {
    font-size: 18px;
    color: #495057;
    font-weight: 500;
  }
  &__intro {
    color: #868e96;
    font-size: 16px;
  }
}
.form {
  padding: 18px 55px 0 110px;
  &__item {
    margin-bottom: 18px;
  }
  .form__btn {
    width: 100%;
  }
}

</style>